import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function OklahomaPage() {
  const [isExpanded, setIsExpanded] = useState(false);

  const oklahomaCities = [
    'Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Edmond', 'Lawton', 'Moore', 'Midwest City',
    'Enid', 'Stillwater', 'Muskogee', 'Bartlesville', 'Owasso', 'Shawnee', 'Ponca City', 'Ardmore',
    'Duncan', 'Del City', 'Yukon', 'Weatherford', 'Woodward', 'Tahlequah', 'McAlester', 'Sapulpa',
    'Claremore', 'El Reno', 'Chickasha', 'Miami', 'Ada', 'Altus', 'Guymon', 'Guthrie', 'Bethany',
    'Mustang', 'Cushing', 'Pryor Creek', 'Sand Springs', 'Clinton', 'Elk City', 'Okmulgee', 'Jenks',
    'Bixby', 'Warr Acres', 'Seminole', 'Blackwell', 'Broken Bow', 'Alva', 'Anadarko', 'Durant',
    'Pauls Valley', 'Sallisaw', 'Grove', 'Sulphur', 'Vinita', 'Idabel', 'Poteau', 'Holdenville',
    'Henryetta', 'Skiatook', 'Coweta', 'Blanchard', 'Tuttle', 'Tecumseh', 'Purcell', 'Newkirk',
    'Tonkawa', 'Perry', 'Kingfisher', 'Choctaw', 'Harrah', 'Noble', 'Piedmont', 'Newcastle',
    'Marlow', 'Madill', 'Atoka', 'Hugo', 'Stigler', 'Eufaula', 'Checotah', 'Okemah', 'Wewoka',
    'Chandler', 'Stroud', 'Bristow', 'Drumright', 'Mannford', 'Cleveland', 'Hominy', 'Pawhuska',
    'Fairfax', 'Pawnee', 'Perkins', 'Ripley', 'Glencoe', 'Stillwater', 'Cushing', 'Yale', 'Drumright'
  ];

  const equipmentTypes = [
    {
      category: 'Fisher Control Valves',
      description: 'Fisher EZ, ED, HP, DVC6000 positioners and complete control valve assemblies',
      brands: ['Fisher', 'Masoneilan', 'Valtek', 'Emerson']
    },
    {
      category: 'Rosemount Transmitters',
      description: 'Rosemount 3051, 2088, 644, 8800 and complete instrumentation packages',
      brands: ['Rosemount', 'Foxboro', 'Yokogawa', 'Honeywell']
    },
    {
      category: 'Safety Relief Valves',
      description: 'Anderson Greenwood, Crosby safety and relief valves all sizes',
      brands: ['Crosby', 'Anderson Greenwood', 'Consolidated', 'Leser']
    },
    {
      category: 'Pipeline Valves',
      description: 'Cameron, Velan, WKM gate valves and ball valves for pipeline service',
      brands: ['Cameron', 'Velan', 'WKM', 'Grove']
    },
    {
      category: 'Actuators & Positioners',
      description: 'Fisher DVC6000, Masoneilan SVI positioners and pneumatic actuators',
      brands: ['Fisher', 'Masoneilan', 'Rotork', 'Bettis']
    },
    {
      category: 'Flow Meters',
      description: 'Micro Motion, Rosemount flow meters and measurement equipment',
      brands: ['Micro Motion', 'Rosemount', 'Endress+Hauser', 'Krohne']
    }
  ];

  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-slate-50 to-slate-100 pt-32 pb-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/e8e88f6c243e85cf1edb47cb9f37bef5.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves Oklahoma</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading industrial equipment buyer in Oklahoma. We purchase surplus valves, control systems, 
              and instrumentation from Tulsa, Ponca City, and all Oklahoma refineries. Above scrap rates, 
              professional service, and turnaround coordination.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:(214) 854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL (214) 854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET OKLAHOMA QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Oklahoma Cities Dropdown Section - SEO Optimized */}
      <section className="py-12 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-full flex items-center justify-between p-6 bg-slate-50 hover:bg-slate-100 rounded-lg transition-all duration-300 group"
            aria-expanded={isExpanded}
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <div className="text-left">
                <h3 className="text-xl font-bold text-slate-900">
                  We Buy Surplus Valves in All Oklahoma Cities
                </h3>
                <p className="text-sm text-slate-600 mt-1">
                  Click to view all {oklahomaCities.length}+ cities we serve across Oklahoma
                </p>
              </div>
            </div>
            <i className={`ri-arrow-down-s-line text-3xl text-slate-600 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}></i>
          </button>

          {/* Expandable Cities Grid */}
          <div
            className={`overflow-hidden transition-all duration-500 ${
              isExpanded ? 'max-h-[2000px] opacity-100 mt-6' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 p-6 bg-slate-50 rounded-lg">
              {oklahomaCities.map((city, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 p-3 bg-white rounded-md hover:bg-teal-50 hover:shadow-sm transition-all duration-200 group"
                >
                  <i className="ri-checkbox-circle-fill text-teal-600 text-sm"></i>
                  <span className="text-sm text-slate-700 group-hover:text-teal-700 font-medium">
                    We Buy Valves {city} OK
                  </span>
                </div>
              ))}
            </div>
            
            {/* Additional SEO Text */}
            <div className="mt-6 p-6 bg-white rounded-lg border border-slate-200">
              <p className="text-sm text-slate-600 leading-relaxed">
                <strong className="text-slate-900">Statewide Oklahoma Valve Buyers:</strong> We purchase surplus Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves from facilities across all Oklahoma cities. Whether you're in Oklahoma City, Tulsa, Edmond, Cushing, Broken Arrow, or any other Oklahoma location, we provide fast quotes, competitive above-scrap pricing, and professional equipment removal services. Our team serves refineries, petrochemical plants, gas processing facilities, and industrial operations throughout the entire state of Oklahoma.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS EQUIPMENT OKLAHOMA</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from Oklahoma industrial facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {equipmentTypes.map((equipment, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{equipment.category}</h3>
                <p className="text-gray-600 mb-6">{equipment.description}</p>
                
                <div className="mb-6">
                  <h4 className="text-gray-800 font-bold mb-3">Top Brands:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {equipment.brands.map((brand, brandIndex) => (
                      <div key={brandIndex} className="bg-[#1B3A5F]/10 text-[#1B3A5F] px-3 py-2 rounded-lg text-sm font-medium text-center">
                        {brand}
                      </div>
                    ))}
                  </div>
                </div>
                
                <Link
                  to="/contact"
                  className="text-[#1B3A5F] font-semibold hover:underline inline-flex items-center"
                >
                  Get Quote for {equipment.category}
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves Oklahoma */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES OKLAHOMA</h2>
            <p className="text-gray-600 text-xl">Oklahoma's trusted surplus valve buyers - serving oil country</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Oklahoma%20surplus%20industrial%20valves%20control%20valves%20gate%20valves%20oil%20refinery%20equipment%20Tulsa%20Ponca%20City%20professional%20valve%20warehouse%20organized%20inventory%20quality%20equipment&width=600&height=400&seq=oklahoma-surplus-valves-006&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Oklahoma Oil Country Valves</h3>
                  <p>Quality surplus valves from Oklahoma's refining and energy facilities</p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">OKLAHOMA SURPLUS VALVE SPECIALISTS</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                We are <strong className="text-[#1B3A5F]">Oklahoma's premier surplus valve buyers</strong>, 
                serving the oil capital and surrounding energy facilities. Our expertise in oil and gas 
                valve applications ensures you receive fair market value for your surplus valve inventory 
                from Tulsa, Ponca City, and throughout Oklahoma.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Oil & Gas Control Valves',
                    description: 'Fisher, Masoneilan control valves from Oklahoma refineries',
                    icon: 'ri-oil-line'
                  },
                  {
                    type: 'Pipeline Valves',
                    description: 'Gate valves, ball valves for pipeline and transmission systems',
                    icon: 'ri-road-map-line'
                  },
                  {
                    type: 'Processing Plant Valves',
                    description: 'Globe valves, check valves from Tulsa area facilities',
                    icon: 'ri-building-line'
                  },
                  {
                    type: 'Safety & Relief Valves',
                    description: 'Anderson Greenwood, Crosby safety valves from energy facilities',
                    icon: 'ri-shield-check-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4 mt-1">
                      <i className={`${valve.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg mb-2">{valve.type}</h4>
                      <p className="text-gray-600">{valve.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-6">
                <h4 className="text-[#1B3A5F] font-bold mb-3">Oklahoma Valve Purchase Benefits:</h4>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Fair market pricing</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">3-7 hour response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-truck-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Statewide pickup</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">20+ years experience</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Major Cities Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">MAJOR OKLAHOMA CITIES WE SERVE</h2>
            <p className="text-gray-600 text-xl">Professional valve buyers in every major Oklahoma energy market</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                city: 'Tulsa',
                description: 'Oil Capital - Major Refining & Energy Hub',
                facilities: '75+ facilities',
                response: '4-6 hours',
                link: '/tulsa'
              },
              {
                city: 'Oklahoma City',
                description: 'Energy Capital - Oil & Gas Companies HQ',
                facilities: '100+ facilities',
                response: '4-6 hours',
                link: '/oklahoma-city'
              }
            ].map((city, index) => (
              <Link 
                key={index}
                to={city.link}
                className="bg-white border-2 border-gray-200 rounded-3xl p-8 hover:shadow-lg hover:border-[#1B3A5F] transition-all duration-300 block"
              >
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{city.city}</h3>
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">{city.description}</p>
                
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between">
                    <span className="text-gray-800 font-semibold">Facilities:</span>
                    <span className="text-[#1B3A5F]">{city.facilities}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-800 font-semibold">Response:</span>
                    <span className="text-[#1B3A5F]">{city.response}</span>
                  </div>
                </div>
                
                <div className="text-[#1B3A5F] font-semibold flex items-center justify-center">
                  View {city.city} Details
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section - Add before Contact Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">OKLAHOMA VALVE BUYERS - FREQUENTLY ASKED QUESTIONS</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment in Oklahoma</p>
          </div>
          
          <div className="space-y-6">
            {[
              {
                question: "Do you buy valves from Oklahoma refineries?",
                answer: "Yes! We specialize in purchasing surplus valves, Fisher control valves, and instrumentation from Oklahoma refineries including Tulsa, Ponca City, Ardmore, and all Oklahoma facilities. We provide fast 4-6 hour response times and competitive pricing for Oklahoma operations."
              },
              {
                question: "What cities in Oklahoma do you serve?",
                answer: "We serve all major Oklahoma cities including Oklahoma City, Tulsa, Ponca City, Ardmore, and surrounding areas. We have local teams throughout Oklahoma ready to respond quickly to your equipment purchasing needs."
              },
              {
                question: "How quickly can you respond to Oklahoma facilities?",
                answer: "We provide 4-6 hour response times for Oklahoma City and Tulsa facilities. Our local Oklahoma teams have extensive energy sector experience and can quickly evaluate your surplus equipment and provide competitive quotes."
              },
              {
                question: "What types of equipment do you buy in Oklahoma?",
                answer: "We purchase all types of industrial equipment from Oklahoma facilities including Fisher control valves, gate valves, globe valves, Rosemount transmitters, flow meters, pressure gauges, safety relief valves, actuators, positioners, and complete instrumentation packages from refineries and energy facilities."
              },
              {
                question: "Do you handle turnaround equipment removal in Oklahoma?",
                answer: "Absolutely! We specialize in turnaround equipment removal and refinery shutdown equipment purchasing throughout Oklahoma. Our experienced teams work within your schedule to maximize value from surplus assets while maintaining full safety compliance."
              },
              {
                question: "What brands of valves do you buy in Oklahoma?",
                answer: "We purchase all major valve brands including Fisher, Masoneilan, Flowserve, Cameron, Emerson, Anderson Greenwood, Crosby, and more. We buy both control valves and manual valves in all sizes and pressure ratings from Oklahoma refineries and energy facilities."
              }
            ].map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-600 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Oklahoma Contact */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">SELL SURPLUS VALVES OKLAHOMA</h2>
            <p className="text-gray-200 text-xl">Professional equipment buyers serving all Oklahoma industrial facilities</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">OKLAHOMA CONTACT</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">(214) 854-5638</div>
                    <div className="text-gray-600">Oklahoma Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">valvesalessupply@gmail.com</div>
                    <div className="text-gray-600">Equipment Photos & Lists</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-4">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Service Territory</h4>
                <p className="text-gray-600">All Oklahoma refineries and petrochemical plants</p>
              </div>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">OKLAHOMA ADVANTAGES</h3>
              <div className="space-y-4">
                {[
                  'Above scrap rates for functional equipment',
                  'Fast response to Oklahoma facilities',
                  'Professional turnaround coordination',
                  'Complete documentation and compliance',
                  'Emergency shutdown support',
                  '20+ years Oklahoma refinery experience'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <Link
                  to="/contact"
                  className="bg-white text-[#1B3A5F] px-10 py-4 rounded-full text-xl font-semibold hover:bg-gray-100 transition-all duration-300 inline-flex items-center whitespace-nowrap"
                >
                  GET OKLAHOMA QUOTE
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
